import { useState, useEffect } from 'react';
import { useFile } from '../../context/FileContext';

/**
 * File tree node component - recursively renders file/folder tree
 */
const TreeNode = ({ node, focusedFilePath, selectedFilePath, onFocusCleared }) => {
  const { loadFile, setSelectedFilePath } = useFile();
  const [isOpen, setIsOpen] = useState(false);
  const isFolder = node.type === 'tree' || (node.children && node.children.length > 0);
  
  // Check if this node or its children contain the focused file
  const isFocused = focusedFilePath && node.path === focusedFilePath;
  const containsFocused = focusedFilePath && node.path && focusedFilePath.startsWith(node.path + '/');
  
  // Check if this node is selected
  const isSelected = selectedFilePath && node.path === selectedFilePath;
  const containsSelected = selectedFilePath && node.path && selectedFilePath.startsWith(node.path + '/');
  
  // Auto-expand folders that contain the focused or selected file
  useEffect(() => {
    if ((containsFocused || containsSelected) && !isOpen) {
      setIsOpen(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusedFilePath, selectedFilePath, node.path]);

  const handleClick = () => {
    setSelectedFilePath(node.path);
    if (isFolder) {
      setIsOpen(!isOpen);
    } else {
      loadFile(node);
      // Only clear focused path if not already loading from URL
      if (!isFocused && onFocusCleared) onFocusCleared();
    }
  };

  return (
    <div style={{ marginLeft: '15px', fontFamily: 'sans-serif' }}>
      <div
        onClick={handleClick}
        style={{ 
          cursor: 'pointer', 
          padding: '2px', 
          userSelect: 'none',
          backgroundColor: isFocused ? '#FFD700' : isSelected ? '#FFE680' : 'transparent',
          fontWeight: isFocused || isSelected ? 'bold' : 'normal',
          borderLeft: isSelected ? '3px solid #FFA500' : 'none',
          paddingLeft: isSelected ? '0px' : '2px'
        }}
      >
        {isFolder ? (isOpen ? '📂 ' : '📁 ') : '📄 '}
        {node.name}
      </div>

      {isFolder && isOpen && (
        <div className="tree-node-row">
          {node.children.map((child, i) => (
            <TreeNode key={i} node={child} focusedFilePath={focusedFilePath} selectedFilePath={selectedFilePath} onFocusCleared={onFocusCleared} />
          ))}
        </div>
      )}
    </div>
  );
};

export default TreeNode;
